module.exports = {"id":"193561","name":"Kelvin Leerdam","rating":"71","photo":"./data/images/photos/2/193561.png","club":{"name":"Seattle Sounders","logo":"./data/images/clubs/SeattleSounders.png"},"positions":["DD","DG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KelvinLeerdam0.json
// module id = 2315
// module chunks = 0